<template>
  <div class="icon-container">
    <div class="icon" :style="{ 'background-color': color }" @click="enterCabinet">
      <span class="icon-text"> {{ cabinetShorthand }} </span>
    </div>
  </div>
</template>

<script setup>
  import router from '@/router'
  import { computed } from 'vue'

  const props = defineProps(['cabinetName', 'color', 'cabinetId'])
  const cabinetShorthand = computed(() => props.cabinetName ? props.cabinetName[0].toUpperCase() + props.cabinetName[1].toLowerCase() : '')
  const enterCabinet = () => router.push({ name: 'search', params: { cabinetId: props.cabinetId }})
</script>

<style scoped lang="scss">
  .icon {
    height: 3rem;
    width: 3rem;
    border-radius: 0.625rem;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    cursor: pointer;
  }

  .icon-container {
    display: flex;
    justify-content: center;
  }

  .icon-text {
    color: white;
    font-weight: bold;
    font-size: 1.25rem;
  }
</style>
